module.exports = __webpack_public_path__ + "2acb60f2/img/note-edit-icon.acae1669.svg";